import {
  parseLocalDate,
  isAnnualEventToday,
  isAnnualEventUpcoming,
} from "@/lib/date";

export const getDateKey = (item) => {
  const date = item.date || item.start_date || item.visit_date;
  return date ? date.slice(0, 10) : "";
};

export const getDateValue = (dateStr) => {
  const d = parseLocalDate(dateStr);
  return d ? d.getTime() : Infinity;
};

export const sortByDate = (a, b) =>
  getDateValue(getDateKey(a)) - getDateValue(getDateKey(b));

export const isBirthdayToday = (birthdate) =>
  isAnnualEventToday(birthdate);

export const isBirthdayUpcoming = (birthdate) =>
  isAnnualEventUpcoming(birthdate, 7);

export const format = (n, word) =>
  `${n} ${word}${n === 1 ? "" : "s"}`;
